import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleSpinner } from './CircleSpinner';
const StepLoader = ({ title, loading, error, children, }) => (_jsxs("div", { children: [_jsx("p", { className: 'flex items-center justify-center text-2xl pb-5', children: title }), loading && _jsx(CircleSpinner, {}), error && _jsx("small", { className: 'text-red-400', children: error }), children] }));
export default StepLoader;
